import shadow from "./shadow-card.module.scss";

import NoImage from "@assets/images/no-image.svg";

const ShadowCard = () => {
  return (
    <div className={`card ${shadow.productTile}`}>
      <div className={`${shadow.productImageBlock} ${shadow.shadowBg}`}>
        <img src={NoImage} alt="" className="img-fluid" />
      </div>
      <div className={`card-body ${shadow.tileFooter}`}>
        <div className={`${shadow.brandTitle} ${shadow.shadowBg}`}></div>
        <div className={`${shadow.productTitle} ${shadow.shadowBg}`}></div>
        <div className={`${shadow.productPoint} ${shadow.shadowBg}`}></div>
      </div>
    </div>
  );
};
export default ShadowCard;
